import React from "react";
import { Link } from "react-router-dom";
import { DeveloperNav } from "./DeveloperNav";
import { Layout } from "features/layout";
import * as paths from "features/routing/paths";

export const Root: React.FC = () => {
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";

  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  const isProd = hostname === "secure.myeyedr.com";
  const isAcceptance = hostname === "secure-acceptance.myeyedr.com";
  const isReviewApp = hostname.endsWith(".herokuapp.com");
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

  const isDevLike = isAcceptance || isReviewApp || isLocal;

  // ✅ Only redirect root on TRUE production
  if (isProd && pathname === "/") {
    window.location.replace("https://www.myeyedr.com/");
    return null;
  }

  // ✅ Non-prod landing page
  if (isDevLike) {
    return (
      <Layout>
        <div>
          <h1>Welcome to MyEyeDr (non-prod).</h1>
        </div>
        <ul>
          <li>
            <a href="/pxp-admin">PxP Administration</a>
          </li>
          <li>
            <Link to={paths.offices()}>Begin Scheduling Process</Link>
          </li>
          <li>
            <a href="/pxp-home">PXP Home</a>
          </li>
          <DeveloperNav />
        </ul>
      </Layout>
    );
  }

  // ✅ Fallback for any other hostnames
  return (
    <Layout>
      <div />
    </Layout>
  );
};

export default Root;
